/**
 * @generated SignedSource<<e7a01d7497da587b3269d40b06b692aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BudgetPageHeader_company$data = {
  readonly id: string;
  readonly tier: TierType | null;
  readonly sageIntacctConnectionEnabled: boolean | null;
  readonly sageIntacctTimeRegsFromForecast: boolean | null;
  readonly currency: string | null;
  readonly " $fragmentType": "BudgetPageHeader_company";
};
export type BudgetPageHeader_company$key = {
  readonly " $data"?: BudgetPageHeader_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"BudgetPageHeader_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetPageHeader_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctTimeRegsFromForecast",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "ac155c28170e033f87246d36767cc658";

export default node;
